import { unloadFinancialSummary } from './summary/action'

export const unloadReports = () => dispatch => {
  dispatch(unloadFinancialSummary())
}
